// 被报人 salInsurelist  混入
import { mapState } from 'vuex';
import moment from 'moment';
export const salInsuredListMixins = {
  computed: {
		...mapState({
      occCode: (state) => state.occupationCode.occCode,//职业code综合
      fileCodeContent: (state) => state.occupationCode.fileCodeContent,//协议文件是否全部已读
    }),
    rowSelection() {
      //输出数据
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows;
        }
      };
    },
    occurOptions() {
      //根据职业类别 筛选职业
      let occulevel = this.addInsured.occulevel;
      var arr = this.$lodash.cloneDeep(this.fileCodeContent.level_tree);
      if (occulevel) {
        arr.forEach(element => {
          element.children.forEach(elem => {
            elem.children = elem.children.filter(item => item.occulevel == occulevel);
          });
					element.children = element.children.filter(item => item.children.length > 0);
        });
        arr = arr.filter(item => item.children.length > 0);
      }
      return arr;
    }
  },
  props: {
    data: {
      // 表格元数据
      type: Array,
      default: () => []
    },
    columns: {
      //表头
      type: Array,
      default: () => []
    },
    disabledAll: {
      //输入框状态
      type: Boolean,
      default: false
    },
    effectiveDate: {
      //生效日期
      type: String,
      default: moment(new Date()).format('YYYY-MM-DD')
    }
  },
  methods: {
    moment,
    filterName(arr) {
      //filter 职业code
      let Code = this.$lodash.cloneDeep(this.fileCodeContent.level_tree);
      let { text } = this.codeFilter(Code, arr[arr.length - 1]);
      return text;
    },
		// 根据职业code，查询出对应职业信息
    filterOccupationItem(arr) {
      //filter 职业code
      let Code = this.$lodash.cloneDeep(this.fileCodeContent.level_tree);
      let item = this.codeFilter(Code, arr[arr.length - 1]);
      return item;
    },
    codeFilter(sourceCode, code) {
      //filter 职业code
      let result = '未找到该职业';
      if (!sourceCode || !sourceCode.length) return;
      // 定义一个数据栈
      let stack = [];
      let item = null;
      //先将第一层节点放入栈
      for (var i = 0, len = sourceCode.length; i < len; i++) {
        stack.push(sourceCode[i]);
      }
      while (stack.length) {
        // 将数据栈的第一个取出来
        item = stack.shift();
        // 如果符合就赋值给result
        if (item.value == code) {
          result = item;
        }
        //如果该节点有子节点，继续添加进入栈底
        if (item.children && item.children.length) {
          stack = stack.concat(item.children);
        }
      }
      return result;
    },
    idNumberChange(e) {
      //根据身份证自动带出性别和生日
      let val = e.target.value;
      let idNoReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
      let gender, birthDate;
      if (idNoReg.test(val)) {
        if (val.slice(16, 17) % 2 == 1) {
          gender = 'M';
        } else {
          gender = 'F';
        }
        birthDate = val.slice(6, 10) + '-' + val.slice(10, 12) + '-' + val.slice(12, 14);
        this.form.setFieldsValue({
          addInsured: {
            birthDate: birthDate,
            gender: gender
          }
        });
      }
    },
    filterSex(val) {
      //性别过滤
      return val == '男' ? 'M' : 'F';
    },
    substitutionType(type) {
      //将证件类型汉字转为value
      var a = type;
      switch (a) {
        case '身份证':
          return 1;
        case '中国护照':
          return 2;
        case '其他':
          return 99;
        default:
          return 1;
      }
    },
    filterIdType(type) {
      //反显身份证text
      if (!parseInt(type)) {
        return type;
      } else {
        var a = parseInt(type);
        switch (a) {
          case 1:
            return '身份证';
          case 2:
            return '中国护照';
          case 99:
            return '其他';
          default:
            return '身份证';
        }
      }
    },
    // 切换全局loading
    toggleLoading(flag) {
      this.$store.commit('setLoading', {
        show: flag
      });
    }
  }
};
